export interface Options {
  type?: string;
  charset?: string;
  async?: boolean;
  attrs?: object;
  text?: string;
}

const defaultOptions = {
  type: 'text/javascript',
  charset: 'utf8',
  async: true
};

function loadScript(
  src: string,
  options?: Options
): Promise<HTMLScriptElement> {
  const head = document.head || document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  const appliedOptions = { ...defaultOptions, ...options };

  script.type = appliedOptions.type;
  script.charset = appliedOptions.charset;
  script.async = appliedOptions.async;
  script.src = src;

  if (appliedOptions.text) {
    script.text = appliedOptions.text;
  }

  if (appliedOptions.attrs) {
    for (const key in appliedOptions.attrs) {
      script.setAttribute(key, appliedOptions.attrs[key]);
    }
  }

  const promise = new Promise<HTMLScriptElement>((resolve, reject) => {
    script.onload = function onload() {
      this.onload = this.onerror = null;
      resolve(script);
    };

    script.onerror = function onerror() {
      this.onload = this.onerror = null;
      reject(new Error(`Failed to load ${this.src}}`));
    };
  });

  head.appendChild(script);
  return promise;
}

export default loadScript;
